export const RefundPolicy = () => (
	<div className="policy-container">
		<h1>Refund Policy</h1>
		<ul>
			<li><strong>Deficiency:</strong> Report service issues within 24 hours for a refund review.</li>
			<li><strong>Processing:</strong> Approved refunds take 5-7 business days to reach your account.</li>
			<li><strong>Refund Request</strong> Contact our support team over email for refund.</li>
		</ul>
		{/* Footer for Legal Connection */}
		<footer style={{ marginTop: '30px', borderTop: '1px solid #ddd', paddingTop: '10px', fontSize: '0.85rem' }}>
			<p>MyBharatService is a registered brand name of <strong>CITIKART ONLINE SERVICE PRIVATE LIMITED</strong>. All rights reserved.</p>
		</footer>
	</div>
);
